import { create } from 'zustand';
import type { User } from '@audiograph/shared';

type SessionUser = User & { permissions?: string[] };

type State = {
  token: string | null;
  user: SessionUser | null;
  setSession: (token: string, user: SessionUser) => void;
  clear: () => void;
};

export const useAuthStore = create<State>((set) => ({
  token: localStorage.getItem('audiograph_token'),
  user: (() => {
    try {
      const raw = localStorage.getItem('audiograph_user');
      return raw ? (JSON.parse(raw) as SessionUser) : null;
    } catch {
      return null;
    }
  })(),
  setSession: (token, user) => {
    localStorage.setItem('audiograph_token', token);
    localStorage.setItem('audiograph_user', JSON.stringify(user));
    set({ token, user });
  },
  clear: () => {
    localStorage.removeItem('audiograph_token');
    localStorage.removeItem('audiograph_user');
    set({ token: null, user: null });
  },
}));

export function hasPermission(permission: string): boolean {
  const user = useAuthStore.getState().user;
  if (!user) return false;
  if (user.role === 'owner') return true;
  return Array.isArray(user.permissions) && user.permissions.includes(permission);
}
